import { render } from "./registrationStep2.vue?vue&type=template&id=3e785de6&scoped=true"
import script from "./registrationStep2.vue?vue&type=script&lang=js"
export * from "./registrationStep2.vue?vue&type=script&lang=js"

import "./registrationStep2.vue?vue&type=style&index=0&id=3e785de6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e785de6"]])

export default __exports__